"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initPaypal = void 0;
const paypal_js_1 = require("@paypal/paypal-js");
const src_1 = require("..");
function initPaypal(payment) {
    return __awaiter(this, void 0, void 0, function* () {
        (0, src_1.setPaypalGatewayPublicId)(payment.public_id);
        if (!(0, src_1.hasPaypalNameSpace)()) {
            const paypalScriptOptions = (0, src_1.getPaypalScriptOptions)(payment.client_id, payment.is_test);
            const paypal = yield (0, paypal_js_1.loadScript)(paypalScriptOptions);
            (0, src_1.setPaypalNameSpace)(paypal);
            if (paypal) {
                yield (0, src_1.paypalOnload)(payment);
            }
        }
        else {
            yield (0, src_1.paypalOnload)(payment);
        }
    });
}
exports.initPaypal = initPaypal;
